module.exports = __webpack_public_path__ + "assets/pin-gray.b3d760a5e684867d53bde1233bbbb769.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/pin/pin-gray.png
// module id = 520
// module chunks = 0